import {Component, Input, OnInit} from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, finalize, map, startWith, switchMap, tap} from 'rxjs/operators';
import {BaseService} from '@shared/services/base.service';
import {environment} from '../../../environments/environment';
import {NgbActiveModal, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {iif, Observable, of} from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import {ToastService} from '../../toast/toast.service';
// import {ErrorHandlingService} from '../../services/error-handling.service';
import {SubmissionService} from '../submission.service';
import {FormsModule} from '@angular/forms';
import {NgIf} from '@angular/common';
import {cloneDeep} from 'es-toolkit';



@Component({
    selector: 'app-lookup-modal',
    templateUrl: './lookup-modal.component.html',
    styleUrls: ['./lookup-modal.component.css'],
    imports: [
        NgbTypeaheadModule,
        FormsModule,
        NgIf
    ]
})
export class LookupModalComponent implements OnInit {
  // @Input() submissionService: SubmissionService;
  @Input() item: { [key: string]: any; } = {};
   @Input() parentItem: { [key: string]: any; } = {};
  @Input() items: { [key: string]: any; } = {};
  @Input() meta;
  @Input() id: string;
  @Input() foreignKey: string;
  searching = false;
  searchFailed = false;
  noMatch = false;
  times = {};
  saving = false;
  genericService: BaseService;
  genericAddService: BaseService;
  open = {};
  saveCanceled = false;
  loadingAutocompleteChoices = false;
  choices = {};
  private submissionAddService: BaseService;
  private submissionLocationService: BaseService;
  private submissionAddMonitoringLocationService: BaseService;

  constructor(private http: HttpClient,
              // private toastService: ToastService,
              public activeModal: NgbActiveModal, public submissionService: SubmissionService) {
  }

  ngOnInit() {
    this.item = {...this.item};
    this.genericService = new BaseService(`${environment.baseUrl}/${this.meta.type}`, this.http);
    this.genericAddService = new BaseService(`${environment.baseUrl}/${this.submissionService.meta.submissionAddType}`, this.http);
    // Object.entries(this.meta.fields).forEach(([key, field]) => {
    // });

  }

  searchData = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => this.genericService.getList({interests: this.meta.interests, search: term, page_size: 1000})),
      map(response => response.results),
      tap(results => this.noMatch = results.length === 0),
          // map(result =>
          //   result.results.filter(v => v[this.meta.autocomplete.field]
          //     .toLowerCase()
          //     .indexOf(term.toLowerCase()) > -1).slice(0, 10),
          // ),
          // tap((res) => {
          //   this.searchFailed = false;
          //   if (res.length == 0) {
          //     this.noMatch = true;
          //   } else {
          //     this.noMatch = false;
          //   }
          // }),
          // catchError(() => {
          //   this.searchFailed = true;
          //   return of([]);
          // }))
      finalize(() => this.searching = false)
    )

formatter = (x: {name: string}) => x[this.meta.autocomplete.field];

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.results.filter(option => option[this.meta.autocomplete.field].toLowerCase().includes(filterValue));
  // }

  cancel() {
    this.activeModal.dismiss('cancel');
  }

  updateMySelection(value) {
   this.item = value;
  }

  ok() {
    if (this.item.globalid !== undefined) {
      this.noMatch = false;
      const submissionId = this.id;
      const addItem = {globalid: submissionId};
      addItem[this.meta.type.slice(this.meta.type.indexOf('/') + 1, this.meta.type.length)] = this.item;
      this.genericAddService.post(addItem).subscribe((response) => {
        
        // this.items.unshift(this.item);
        // this.meta.count++;
        // if (this.meta.hasOwnProperty('refreshProperties')) {
        //     this.meta.refreshProperties(this.parentItem);
        //   }
        this.activeModal.close(this.item);
        // this.resetMeta(this.meta);
      });
    } else {
      this.noMatch = true;
      // this.toastService.warning('Error: Please select item from dropdowm to add.');

    }
  }
    resetMeta(meta) {
    this.meta = cloneDeep(meta);
  }
}
